<template>
  <div 
    v-if="receipt"
    :key="receipt.id"
    :style="receiptStyle"
  >
    <v-layout
      row
      align-center
      @click="showReceipt"
    >
      <v-flex
        xs10
        class="nowrap-text"
        :style="nameStyle"
      >
        {{ printDate(receipt.open_date) }}
      </v-flex>
      <v-flex
        xs2
        text-xs-right
      >
        <v-btn
          icon
          small
        >
          <v-icon
            :color="theme.btn_color_secondary"
            small
          >fa-chevron-right</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout
      row
      align-center
    >
      <v-flex 
        xs12
        class="sub-text"
      >
        <span :style="nameStyle">{{ $t('paid_amount') }}:</span>
        <span class="status" :style="statusStyle">{{ $n(receipt.total, 'currency') }}</span>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  props: {
    receipt: {
      type: Object,
      default: null
    },
    receiptStyle: {
      type: Object,
      default: () => ({
        cursor: 'pointer'
      })
    },
    index: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme'
    ]),
    nameStyle () {
      return {
        color: this.theme.orders_title_color
      }
    },
    statusStyle () {
      return {
        color: this.theme.orders_success_color
      }
    },
  },
  methods: {
    printDate (d) {
      const d2 = moment(d)
      const today = moment()
      const yesterday = moment().subtract(1, 'day')
      if (d2.isSame(today, 'day')) return this.$t('today_at') + d2.format('h:mm A')
      if (d2.isSame(yesterday, 'day')) return this.$t('yesterday_at') + d2.format('h:mm A')
      return d2.format('D MMMM YYYY \\at h:mm A')
    },
    showReceipt () {
      this.$router.push({ name: 'receipt', params: { id: this.receipt.id.toString() }})
    }
  }
}
</script>

<style scoped>
.status {
  font-weight: 500;
}
.nowrap-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}
.sub-text {
  font-size: small;
}
</style>



// WEBPACK FOOTER //
// src/components/ReceiptLine.vue